// MC => mopar connect
// TBM => telematics box module
module.exports = {
  MC: 'mc',
  TBM: 'tbm',
};
